import React from "react";

export default function apartmentDetails(props) {
  return (
    <React.Fragment>
      <div className="container card apartment_card">
        <header className="apartment_card_header">{props.apartment.name}</header>
        <div className="apartment_card_inner">
          <p className="apartment_furnished">
            Furnished - {props.apartment.furnished ? <React.Fragment>&#9989;</React.Fragment> : <React.Fragment>&#10060;</React.Fragment>}
          </p>
          <hr />
          {props.apartment.roomType ? (
            <React.Fragment>
              <section>
                <header>
                  <span className="apartment_roomType">Room Type</span>
                </header>
              </section>
              <p> {props.apartment.roomType}</p>
            </React.Fragment>
          ) : null}
          <React.Fragment>
            <section>
              <header>
                <span className="apartment_roomType">Bus Service</span>
              </header>
            </section>
            <div>
              {" "}
              {props.apartment.busService.map((bus, index) => {
                return (
                  <p key={"Bus" + index}>
                    <strong>{bus.split(":")[0]}</strong>-<span>{bus.split(":")[1]}</span>
                  </p>
                );
              })}
            </div>
          </React.Fragment>
          <React.Fragment>
            <section>
              <header>
                <span className="apartment_roomType">Bus Frequency</span>
              </header>
            </section>
            <p>{props.apartment.busFreq}</p>
          </React.Fragment>

          <React.Fragment>
            <section>
              <header>
                <span className="apartment_roomType">Distance from Tate Center</span>
              </header>
            </section>
            <p>{props.apartment.distFromTC}</p>
          </React.Fragment>

          {props.apartment.availability ? (
            <React.Fragment>
              <section>
                <header>
                  <span className="apartment_roomType">Availability</span>
                </header>
              </section>
              <p>{props.apartment.availability}</p>
            </React.Fragment>
          ) : null}

          <React.Fragment>
            <section>
              <header>
                <span className="apartment_roomType">PROS</span>
              </header>
            </section>
            <div>
              <ul>
                {props.apartment.pros.map((point, index) => {
                  return (
                    <React.Fragment key={"PROS" + index}>
                      <li>{point}</li>
                    </React.Fragment>
                  );
                })}
              </ul>
            </div>
          </React.Fragment>

          <React.Fragment>
            <section>
              <header>
                <span className="apartment_roomType">CONS</span>
              </header>
            </section>
            <div>
              <ul>
                {props.apartment.cons.map((point, index) => {
                  return (
                    <React.Fragment key={"CONS" + index}>
                      <li>{point}</li>
                    </React.Fragment>
                  );
                })}
              </ul>
            </div>
          </React.Fragment>
        </div>
      </div>
    </React.Fragment>
  );
}
